import { render, staticRenderFns } from "./text.vue?vue&type=template&id=6c79d030"
import script from "./text.vue?vue&type=script&lang=js"
export * from "./text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c79d030')) {
      api.createRecord('6c79d030', component.options)
    } else {
      api.reload('6c79d030', component.options)
    }
    module.hot.accept("./text.vue?vue&type=template&id=6c79d030", function () {
      api.rerender('6c79d030', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/component/text.vue"
export default component.exports